import {
  BlogData,
  ChangeEvent,
  DynamicContentType,
} from '@bm-js/atlascloud-shared'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<BlogData>
  setData: (e: ChangeEvent) => void
}

const BlogEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <Select
        light
        label={tr(TrKey.blogEditorMarginBottomLabel)}
        desc={tr(TrKey.blogEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.blogEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default BlogEditor
